import React from 'react';

type Props = {
	children ?: any
}

function GuestLayout(props:Props) {
	return (
		<React.Fragment>
			<div className="authentication-header"/>
			{props.children}
		</React.Fragment>
	);
}

export default GuestLayout;